import { markRaw, type Component } from 'vue'
import {
  useSheet,
  type SheetHeight,
  type SheetOpenOptions,
} from '@dacr/library'

export enum Sheets {
  CopyrightRegistration,
  UploadSelectOwner,
  UploadFilesList,
  UploadSelectFolder,
  UploadConfirm,
  UploadJurisdictions,
  UploadPricingDetails,
  FileActions,
  FolderActions,
  ThreeDotsMenu,
  ArchiveMenu,
  NotificationMenu,
  FolderInfo,
  SelectCopyrightOwner,
  InfringementMenu,
  SearchFilter,
  SearchSort,
}

interface SheetEntry {
  component: Component
  height?: SheetHeight
}

const registry = new Map<Sheets, SheetEntry>()

export const registerSheet = (
  name: Sheets,
  component: Component,
  height?: SheetHeight
) => {
  registry.set(name, { component: markRaw(component), height })
}

export const openSheet = (name: Sheets, opts?: SheetOpenOptions) => {
  const entry = registry.get(name)
  if (!entry) return
  return useSheet().open(entry.component, {
    height: entry.height,
    ...opts,
    name: Sheets[name],
  })
}

export const closeAllSheets = () => useSheet().closeAll()
